import { useMutation, useQuery } from 'react-query'
import {
  generateApiKey,
  getNotifications,
  removeNotification,
  updateNotificationRead,
} from '../api/investorApi'
import { queryClient } from './client'

export function useGetNotifications() {
  return useQuery({
    queryKey: 'getNotifications',
    queryFn: getNotifications,
  })
}
export function useGenerateApiKey(isEnable: boolean) {
  return useQuery({
    queryKey: 'generateApiKey',
    queryFn: generateApiKey,
    enabled: isEnable,
  })
}

export function useRemoveNotification() {
  return useMutation({
    mutationKey: 'removeNotification',
    mutationFn: removeNotification,

    onSuccess: () => {
      queryClient.invalidateQueries('getNotifications')
    },
    onError: () => {},
  })
}

export function useUpdateNotificationRead() {
  return useMutation({
    mutationKey: 'updateNotificationRead',
    mutationFn: updateNotificationRead,

    onSuccess: () => {
      queryClient.invalidateQueries('getNotifications')
    },
    onError: () => {},
  })
}
